import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-my-productlist',
  templateUrl: './my-productlist.component.html',
  styleUrls: ['./my-productlist.component.scss'],
})
export class MyProductlistComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
